import React from "react";
import Popup from "reactjs-popup";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GPAP_Button_Orange } from "../../../../gpap-lib/Button_Collection";

const PopupMessage = (props) =>{
    return (
        <Popup open={true}>
            <div>
                <div className="page-header"> <h1> {props.title} </h1> </div>
                <div className="alert alert-warning"> {props.message} </div>
                <GPAP_Button_Orange href={props.href}  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_Orange>
            </div>
        </Popup>);
}

export default PopupMessage;